import { useContext } from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { GeodataContext } from 'contexts/GeodataContext';

interface BuildingsProps {
  readOnly?: boolean;
  hideIncludeToggle?: boolean;
}

const Buildings = ({ readOnly = false, hideIncludeToggle = false }: BuildingsProps) => {
  const { geodata, geodataParams, setGeodata, setGeodataParams } = useContext(GeodataContext);

  const includeBuildings = Boolean(geodata?.buildingsEnabled);
  const includeBuildingsInAnalysisArea = Boolean(geodataParams?.isBuildingInAnalysisArea);

  return (
    <div className="geodata-section-block">
      {!hideIncludeToggle && (
        <FormControlLabel
          className="checkbox-row"
          control={
            <Checkbox
              checked={includeBuildings}
              disabled={readOnly}
              onChange={(event) =>
                setGeodata((prev) => ({
                  ...prev,
                  buildingsEnabled: event.target.checked,
                }))
              }
            />
          }
          label="Include buildings"
        />
      )}

      <FormControlLabel
        className="checkbox-row"
        control={
          <Checkbox
            checked={includeBuildingsInAnalysisArea}
            disabled={readOnly || !includeBuildings}
            onChange={(event) =>
              setGeodataParams({
                isBuildingInAnalysisArea: event.target.checked,
                ...(event.target.checked ? {} : { buildingsAsProjectSketches: false }),
              })
            }
          />
        }
        label="Buildings inside Analysis Area"
      />

      <FormControlLabel
        className="checkbox-row"
        control={
          <Checkbox
            checked={Boolean(includeBuildingsInAnalysisArea && geodataParams?.buildingsAsProjectSketches)}
            disabled={readOnly || !includeBuildings || !includeBuildingsInAnalysisArea}
            onChange={(event) =>
              setGeodataParams({
                buildingsAsProjectSketches: event.target.checked,
              })
            }
          />
        }
        label="Convert into Project Sketches"
      />
    </div>
  );
};

export default Buildings;
